<template>
    <!-- Large screens -->
    <div class="d-flex w-100 align-items-center" v-if="width > 992">
        <!-- Search placeholder -->
        <div ref="searchPlaceholder" class="searchPlaceholder p-4-1 col-lg-12" @click="showSearchContainer">
            <i class="bi-search small-icon text-body"></i>
            <p class="m-0">Search</p>
        </div>

        <!-- Main container -->
        <div ref="searchContainer" class="searchContainer col-lg-12 hidden">
            <div class="searchInputContainer p-4-1 bg-white border-bottom">
                <!-- Loading Icon -->
                <i ref="loaderIcon" class="d-none small-icon bi-x-lg loading"></i>
                <!-- Search icon -->
                <i ref="lgSearchIcon" class="bi-search hoverable-icon small-icon text-body"></i>
                <!-- Search input -->
                <input ref="searchInput" type="text" class="form-control p-0 px-3 border-0 bg-white h-100"
                    placeholder="Search" enterkeyhint="go" v-model="search">
                <!-- Clear button -->
                <i ref="clearButton" class="bi-x-lg small-icon hoverable-icon text-body d-none"
                    @click="clearSearchInput" v-ripple></i>
            </div>
            <!-- Search results container -->
            <div class="card border-0" ref="lgResultCard">
                <ResultsCard size-class="lg" class="d-none" :search="search"
                    @loading-content="(val) => toggleSearchDisable(val)"></ResultsCard>
            </div>
        </div>
    </div>

    <template v-else>
        <!-- Small screens -->
        <div ref="searchPlaceholder" class="searchPlaceholder" data-bs-toggle="offcanvas"
            data-bs-target="#offcanvasSearch" aria-controls="offcanvasSearch" v-if="route.name == 'home'">
            <i class="bi-search small-icon text-body"></i>
            <p class="m-0">Search</p>
        </div>

        <!-- Search offcanvas -->
        <div class="offcanvas offcanvas-end w-100 text-body" data-bs-backdrop="false" tabindex="-1" id="offcanvasSearch"
            ref="offcanvasSearch">
            <!-- Offcanvas header -->
            <div class="offcanvas-header border-bottom">
                <!-- Search toggler -->
                <i class="bi-arrow-left me-2" data-bs-dismiss="offcanvas" v-ripple></i>
                <!-- Search input -->
                <input ref="searchInput" type="text" class="form-control p-0 border-0 bg-white" placeholder="Search"
                    enterkeyhint="go" v-model="search">
                <!-- Clear button -->
                <i ref="clearButton" class="d-none small-icon bi-x-lg ms-4 me-2" @click="clearSearchInput" v-ripple></i>
                <!-- Loading icon -->
                <i ref="loaderIcon" class="d-none small-icon bi-x-lg ms-4 me-2 loading"></i>
            </div>
            <!-- Search results container -->
            <div class="offcanvas-body p-0" ref="smResultCard">
                <ResultsCard size-class="sm" class="d-none" :search="search"
                    @loading-content="(val) => toggleSearchDisable(val)"></ResultsCard>
            </div>
        </div>
    </template>
</template>

<script setup>
import { ref, watch } from "vue";
import Dropdown from 'bootstrap/js/dist/dropdown';
import offcanvas from 'bootstrap/js/dist/offcanvas';
import ResultsCard from "./ResultsCard.vue";
import { useRoute } from 'vue-router';
import { useWindowSize } from '@vueuse/core'

const searchPlaceholder = ref(null);
const searchContainer = ref(null);
const searchInput = ref(null);
const clearButton = ref(null);
const lgSearchIcon = ref(null);
const lgResultCard = ref(null);
const smResultCard = ref(null);
const offcanvasSearch = ref(null);
const hasResults = ref(false);
const loaderIcon = ref(false);

const search = ref('');
watch(search, (val) => {
    if (val && val.trim().length > 0) {
        toggleClearButton();
    }
    else {
        clearSearchInput();
    }
})

const { width } = useWindowSize()
const route = useRoute();

const clearSearchInput = () => {
    searchInput.value.value = '';
    searchInput.value.focus();
    clearButton.value.classList.add("d-none");

    if (width.value > 992) {
        lgResultCard.value.children[0]?.classList.add("d-none");
        searchContainer.value.children[0]?.classList.remove("hasResults");
    }
    else {
        smResultCard.value.children[0]?.classList.add("d-none");

    }
    loaderIcon.value.classList.add("d-none");
    hasResults.value = false;
}

const toggleResultsDiv = () => {
    if (width.value > 992)
        if (searchInput.value.value.length > 0) {
            // lgSearchIcon.value.classList.add("d-none");
            // loaderIcon.value.classList.remove("d-none");
            if (hasResults.value) {
                lgResultCard.value.children[0].classList.remove("d-none");
                searchContainer.value.children[0].classList.add("hasResults");
            }
            setTimeout(() => {
                if (!hasResults.value) {
                    lgResultCard.value.children[0].classList.remove("d-none");
                    searchContainer.value.children[0].classList.add("hasResults");
                    hasResults.value = true;
                }
                // lgSearchIcon.value.classList.remove("d-none");
                // loaderIcon.value.classList.add("d-none");
            }, 1000)
        } else {
            lgResultCard.value.children[0].classList.add("d-none");
            searchContainer.value.children[0].classList.remove("hasResults");
            hasResults.value = false;
        }
    else
        if (searchInput.value.value.length > 0) {
            // loaderIcon.value.classList.remove("d-none");
            // clearButton.value.classList.add("d-none");
            if (hasResults.value) smResultCard.value.children[0].classList.remove("d-none");
            setTimeout(() => {
                if (!hasResults.value) {
                    smResultCard.value.children[0].classList.remove("d-none");
                    hasResults.value = true;
                }
                // loaderIcon.value.classList.add("d-none");
                // clearButton.value.classList.remove("d-none");
            }, 1000)
        }
        else {
            smResultCard.value.children[0].classList.add("d-none");
            hasResults.value = false;
        }

}

const toggleClearButton = () => {
    if (searchInput.value.value.length > 0) {
        clearButton.value.classList.remove("d-none");
    } else {
        clearButton.value.classList.add("d-none");
    }
}

const isSearchInputDisabled = ref(false);
const toggleSearchDisable = (val) => {
    isSearchInputDisabled.value = val;
    if (width.value > 992) {
        if (isSearchInputDisabled.value) {
            lgSearchIcon.value.classList.add("d-none");
            loaderIcon.value.classList.remove("d-none");
        }
        else {
            lgSearchIcon.value.classList.remove("d-none");
            loaderIcon.value.classList.add("d-none");
        }
    }
    else {
        if (isSearchInputDisabled.value) {
            loaderIcon.value.classList.remove("d-none");
            clearButton.value.classList.add("d-none");
        }
        else {
            loaderIcon.value.classList.add("d-none");
            clearButton.value.classList.remove("d-none");
        }
    }

    if (width.value > 992) {
        if (isSearchInputDisabled.value) {
            lgResultCard.value.children[0]?.classList.add("d-none");
            searchContainer.value.children[0]?.classList.remove("hasResults");
            hasResults.value = false;
        }
        else {
            lgResultCard.value.children[0]?.classList.remove("d-none");
            searchContainer.value.children[0]?.classList.add("hasResults");
            hasResults.value = true;
        }
    }
    else {
        if (isSearchInputDisabled.value) {
            smResultCard.value.children[0]?.classList.add("d-none");
            hasResults.value = false;
        }
        else {
            smResultCard.value.children[0]?.classList.remove("d-none");
            hasResults.value = true;
        }
    }
    if (searchInput.value.value.length == 0) {
        hasResults.value = false;
        loaderIcon.value.classList.add("d-none");
        if (width.value > 992) {
            lgResultCard.value.children[0]?.classList.add("d-none");
            searchContainer.value.children[0]?.classList.remove("hasResults");
            lgSearchIcon.value.classList.remove("d-none");
        }
        else {
            smResultCard.value.children[0]?.classList.add("d-none");
            clearButton.value.classList.add("d-none");
        }
    }

}

const handleSearchInput = () => {
    // toggleClearButton();
    // toggleResultsDiv()
};

const showSearchDiv = () => {
    searchContainer.value?.classList.add("position-relative");
    searchContainer.value?.classList.remove("hidden");
    searchPlaceholder.value?.classList.add("hidden");
    if (searchInput.value) searchInput.value.value = "";
    clearButton.value?.classList.add("d-none");
    document.body.classList.add("fade-back");
    hasResults.value = false;
}

const hideDropdowns = () => {
    const dropdownElementList = document.querySelectorAll('.dropdown-toggle');
    dropdownElementList.forEach(el => new Dropdown(el).hide())
}

const showSearchContainer = (e) => {
    e.stopImmediatePropagation();
    hideDropdowns();
    showSearchDiv();
    searchInput.value.focus();
}

watch(offcanvasSearch, (currentValue, oldValue) => {
    if (currentValue != null) {
        currentValue.addEventListener("shown.bs.offcanvas", () => {
            searchInput.value.focus();
        })
        currentValue.addEventListener("hidden.bs.offcanvas", () => {
            if (searchInput.value) searchInput.value.value = '';
            smResultCard.value?.children[0].classList.add("d-none");
            hasResults.value = false;
        })
    }
});
</script>
<style scoped lang="scss">
.p-4-1 {
    padding: 0.4rem 1rem !important;
}
</style>